import { useMemo, useState } from 'react';
import { getDataTableColumns } from '../cols-definition';

export const useTableData = (hoaDonBanDichVus: BanHangRecord[] = [], handleViewClick: (row: BanHangRecord) => void) => {
  const [detailRows, setDetailRows] = useState<BanHangRecord[]>([]);
  const columns = useMemo(() => getDataTableColumns(handleViewClick), [handleViewClick]);

  const { totalAmount, totalDiscount, totalTax } = useMemo(() => {
    const amount = detailRows.reduce((sum, row) => sum + (row.tien_nt2 || 0), 0);
    const discount = detailRows.reduce((sum, row) => sum + (row.ck_nt || 0), 0);
    const tax = detailRows.reduce((sum, row) => sum + (row.thue_nt || 0), 0);
    return { totalAmount: amount, totalDiscount: discount, totalTax: tax };
  }, [detailRows]);

  const tables = [
    {
      name: 'Tất cả',
      rows: hoaDonBanDichVus,
      columns
    },
    {
      name: 'Chưa ghi sổ',
      rows: hoaDonBanDichVus.filter(row => row.status === '0'),
      columns,
      icon: <div className='mr-2 size-[7px] rounded-full bg-[#EAD1DC]' />
    },
    {
      name: 'Đã ghi sổ',
      rows: hoaDonBanDichVus.filter(row => row.status === '3'),
      columns,
      icon: <div className='mr-2 size-[7px] rounded-full bg-[#3D85C6]' />
    },
    {
      name: 'Chờ duyệt',
      rows: hoaDonBanDichVus.filter(row => row.status === '5'),
      columns,
      icon: <div className='mr-2 size-[7px] rounded-full bg-red-500' />
    },
    {
      name: 'Khác',
      rows: hoaDonBanDichVus.filter(row => row.status !== '0' && row.status !== '3' && row.status !== '5'),
      columns,
      icon: <div className='mr-2 size-[7px] rounded-full bg-black' />
    }
  ];

  return {
    hoaDonBanDichVus,
    detailRows,
    totalAmount,
    totalDiscount,
    totalTax,
    tables,
    setDetailRows
  };
};
